import { getPackage2025DateID } from "@/state/lakefront/package-2025";
import { getPackage2026DateID } from "@/state/lakefront/package-2026";
import { getPackage2027DateID } from "@/state/lakefront/package-2027";

const supported2025PackageIds = [251, 252];
const supported2026PackageIds = [254, 255, 256, 257, 258, 259, 260];
const supported2027PackageIds = [261];

export const packageDateMapper = packageId => {
  if (supported2025PackageIds.includes(packageId)) {
    return getPackage2025DateID;
  } else if (supported2026PackageIds.includes(packageId)) {
    return getPackage2026DateID;
  } else if (supported2027PackageIds.includes(packageId)) {
    return getPackage2027DateID;
  }
  return undefined;
};
